import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeDocumentAllowedExtensionsList } from './normalize';

export const fetchDocumentAllowedExtensionsList = createProvider(api.fetchDocumentAllowedExtensionsList)
  .andThen((res) => normalizeDocumentAllowedExtensionsList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
